<link rel="ractive" href="../r-page.html" name="r-page">
<link rel="ractive" href="../components/header.html" name="c-gp-header">
<link rel="ractive" href="../components/google-maps.html" name="c-google-maps">
<link rel="ractive" href="../components/footer.html" name="c-gp-footer">
<link rel="ractive" href="../components/notification.html" name="c-notification">
<link rel="ractive" href="../components/filtered-probe-list.html" name="c-filtered-probe-list">

<r-page noYield="{{noYield}}" title="{{title}}" description="{{description}}">
	<c-notification />

	<c-gp-header additionalClasses="header-with-globalping-bg" />

	<div class="gp-network">
		<div class="gp-network_hero">
			<div class="gp-network_stats">
				<div class="gp-network_stats_item">
					<img src="{{@shared.assetsHost}}/img/radio.svg">
					<b>{{filteredProbesStats.count}}</b> {{_.pluralize('probe', filteredProbesStats.count)}}
				</div>
				<div class="gp-network_stats_item">
					<img src="{{@shared.assetsHost}}/img/file-text.svg">
					<b>{{filteredProbesStats.asns}}</b> {{_.pluralize('ASN', filteredProbesStats.asns)}}
				</div>
			</div>

			<div class="gp-network_hero_map-wrapper">
				<c-google-maps
					class="gp-network_hero_map-wrapper_map"
					iwClass="gp-network_iw"
					probesByCoords="{{filteredMarkersData}}"
					hasCluster="{{true}}"
					onProbesByCoordsChange="{{@this.handleProbesByCoordsChange}}"
				/>
			</div>
		</div>

		<div class="gp-network_filtered-list">
			<c-filtered-probe-list
				rawProbes="{{probesResponse}}"
				filteredProbes="{{filteredProbes}}"
				location="{{location}}"
				locationCompletedValue="{{locationCompletedValue}}"
				groupBy="{{groupBy}}"
				sortOrder="{{sortOrder}}"
				refresh="{{@this.getProbesData}}"
				probesLoading="{{probesLoading}}"
				probesError="{{probesError}}"
				defaultSortOptions="{{defaultSortOptions}}"
				filter="{{filter}}"
			/>
		</div>
	</div>

	<c-gp-footer></c-gp-footer>
</r-page>

<script>
	const _ = require('../../assets/js/_');
	const listeners = require('../../assets/js/utils/listeners');
	const dataCache = require('../../assets/js/utils/data-cache');
	const http = require('../../assets/js/utils/http');

	const GROUP_DEFAULT = 'city';

	const DEFAULT_SORT_OPTIONS = {
		'country': 'alphabetically',
		'city': 'alphabetically',
		'network': 'probe-count',
		'country-network': 'alphabetically',
		'city-network': 'alphabetically',
		'disabled': 'alphabetically',
	};

	component.exports = {
		data () {
			return {
				_,
				title: 'Network - Globalping',
				description: 'Explore the global network map of Globalping probes.',
				location: 'World',
				locationCompletedValue: '',
				groupBy: GROUP_DEFAULT,
				sortOrder: DEFAULT_SORT_OPTIONS[GROUP_DEFAULT],
				defaultSortOptions: DEFAULT_SORT_OPTIONS,
				probesResponse: null,
				probesLoading: false,
				probesError: null,
				filteredProbes: null,
				filteredMarkersData: null,
				filteredProbesStats: null,
			};
		},
		computed: {
			filter: {
				get () {
					let location = this.get('locationCompletedValue') || '';

					if (location.toLowerCase() === 'world') {
						return '';
					}

					return location.replace(/\+/g, '%');
				},
				set (location) {
					this.set('location', location.replace(/%/g, '+'));
					this.set('locationCompletedValue', location.replace(/%/g, '+'));
				},
			},
			group: {
				get () {
					return this.get('groupBy') === GROUP_DEFAULT ? '' : this.get('groupBy');
				},
				set (group) {
					this.set('groupBy', group);

					if (Object.hasOwn(DEFAULT_SORT_OPTIONS, group)) {
						this.set('sortOrder', DEFAULT_SORT_OPTIONS[group]);
					}
				},
			},
			sort: {
				get () {
					return this.get('sortOrder') === DEFAULT_SORT_OPTIONS[this.get('groupBy')] || this.get('groupBy') === 'disabled' ? '' : this.get('sortOrder');
				},
				set (sort) {
					this.set('sortOrder', sort);
				},
			},
		},
		oninit () {
			if (!Ractive.isServer) {
				this.getProbesData();

				this.observe('filteredProbes', (filteredProbes) => {
					if (filteredProbes === null) {
						return;
					}

					// recalculate ASNs
					let asns = filteredProbes.reduce((asns, probe) => {
						asns.add(probe.location.asn);
						return asns;
					}, new Set());

					this.set('filteredProbesStats', { count: filteredProbes.length, asns: asns.size });

					// recalculate map markers
					let groupedByCoords = filteredProbes.reduce((res, probe) => {
						let coords = `${probe.location.latitude}, ${probe.location.longitude}`;

						// group by Coordinates
						if (!Object.hasOwn(res, coords)) {
							res[coords] = [];
						}

						res[coords].push(probe);

						return res;
					}, {});

					setTimeout(() => this.set('filteredMarkersData', groupedByCoords), 50);
				});
			}
		},
		onrender () {
			if (!Ractive.isServer) {
				listeners.screenWidthListener(this);
			}
		},
		getProbesData () {
			this.set('probesLoading', true);
			this.set('probesError', null);

			dataCache.getCache('probesResponse', 60 * 1000, http.fetchGlobalpingProbes)
				.then(value => this.set('probesResponse', value))
				.catch((error) => {
					console.error('Failed to fetch probes', error);
					this.set('probesError', error);
				})
				.finally(() => this.set('probesLoading', false));
		},
		handleProbesByCoordsChange () {
			let locationCompletedValue = this.get('locationCompletedValue');
			return !!locationCompletedValue?.length;
		},
	};
</script>
